
/**
 * Canonical identifiers for every tool type.
 * Use these constants instead of raw string literals throughout the codebase.
 */
export enum ToolType {
  ESV        = 'ESV',
  ESG        = 'ESG',
  LCA        = 'LCA',
  SFR        = 'SFR',
  OPV        = 'OPV',
  ST         = 'ST',
  SFCR       = 'SFCR',
  CNP        = 'CNP',
  NLL        = 'NLL',
  NLS        = 'NLS',
  GS         = 'GS',
  IFRS17_NL  = '17NL',
  IFRS17_L   = '17L',
  CI         = 'CI',
  IAS19      = 'IAS19',
  PNRR       = 'PNRR',
  PET        = 'PET',
  ILL        = 'ILL',
  C4E        = 'C4E',
  DBT        = 'DBT',
  RO         = 'RO',
  NEWRO      = 'NEWRO',
  NICE       = 'NICE',
}

/** Tools whose viewer is an embedded PowerBI report. */
export const POWERBI_TOOLS: ToolType[] = [
  ToolType.ESV, ToolType.ESG, ToolType.LCA, ToolType.SFR,
];

/**
 * Tools that use the legacy /tool/:type/:id routing pattern.
 * New tools added after this list was defined fall through to a different route.
 */
export const LEGACY_TOOLS: ToolType[] = [
  ToolType.NLL,      ToolType.NLS,      ToolType.ESV,  ToolType.ESG,
  ToolType.GS,       ToolType.CI,       ToolType.LCA,  ToolType.PNRR,
  ToolType.RO,       ToolType.NEWRO,    ToolType.DBT,  ToolType.ST,
  ToolType.IFRS17_NL, ToolType.IFRS17_L, ToolType.SFR, ToolType.OPV,
  ToolType.CNP,      ToolType.SFCR,
];

/**
 * Show tools completed name
 */

export enum ToolsCompletedName {
  ESG = 'ESG',
  GS = 'GS',
  NLL = 'NL (local)',
  NLS = 'NL (solvency)'
}

/**
 * Check if the tool exists and icon === 'glyph' return the icon to show in toolbar or tool navbar
 * otherwise return an icon for directories or executions connected to a specific tool.
 * If the tool don't exist return the icons for each type of entity
 *
 * PS: when adding a new tool, you must be added the corresponding color
 * in the file AoFTool_Frontend/AofTool-Frontend/src/assets/styles/partials/_variables.scss with tool name.
 * The name of the new svg file must respect the following format:
 * 'type_' + ('directory' | 'execution') + '_' + toolName + '.svg'
 *
 * @param icon type of entity (workspace, project, directory, execution) or 'glyph'
 * @param tool tool name
 */
export function getToolIcon(icon: string | 'glyph', tool?: string,) {
  if (tool) {
    if (icon === 'glyph') {
      return '/assets/images/tool_' + tool + '.svg';
    } else {
      return 'assets/images/type_' + icon + '_' + tool + '.svg';
    }
  } else {
    return 'assets/images/type_' + icon + '.svg';
  }
}

export function getEvaluationCI(x:number){
  if (x > 8) return 'Very high';
  if (x > 6) return 'High';
  if (x > 4) return 'Medium';
  if (x > 0.1) return 'Low';
  return 'Absent';
}

export function getColorArrayIndex(x:number){
  if (x > 8) return 3;
  if (x > 6) return 2;
  if (x > 4) return 1;
  if (x > 0.1) return 0;
  return 0;
}
